import { Modal } from 'antd';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share';

import { Note } from '../../../../helbest';

const icons_list = [
  { key: 'email', main_icon: EmailShareButton, child_icon: EmailIcon },
  { key: 'whatsapp', main_icon: WhatsappShareButton, child_icon: WhatsappIcon },
  { key: 'telegram', main_icon: TelegramShareButton, child_icon: TelegramIcon },
  { key: 'twitter', main_icon: TwitterShareButton, child_icon: TwitterIcon },
  { key: 'facebook', main_icon: FacebookShareButton, child_icon: FacebookIcon }
];

const ShareModal = ({ setShareModal, shareModal, value }) => {
  const copy = (e) => {
    const i = e.target;
    i.select();
    i.setSelectionRange(0, 99999);
    document.execCommand('copy');
    Note.info('لینک محصول کپی شد.', 'bottom-center');
  };

  return (
    <Modal
      className="increase-credit-modal"
      closable={true}
      footer={false}
      maskClosable={true}
      onCancel={() => setShareModal(false)}
      visible={shareModal}
      width="100%">
      <p className="font-12 text-center">
        با استفاده از روش‌های زیر می‌توانید این صفحه را با دوستان خود به اشتراک بگذارید. برای کپی
        کردن لینک بر روی آن کلیک کنید.
      </p>

      <input
        className="share-input font-12"
        onClick={(e) => copy(e)}
        readOnly
        type="text"
        value={value}
      />

      <div className="text-center mar-t-10">
        {icons_list.map((icons_item) => (
          <icons_item.main_icon key={icons_item.key} className="mar-l-10" url={value}>
            <icons_item.child_icon round={true} size={32} />
          </icons_item.main_icon>
        ))}
      </div>
    </Modal>
  );
};

export default ShareModal;
